<template>
<component :is="'C' + eType"
           v-model="model"
           v-bind="properties"
           :account="account"
           :data-qa="dataQa"
           :state-id="stateId"
           :focused="focused"
           @focus="$emit('focus')"
           @blur="$emit('blur')"
           @finished="$emit('finished', id)"/>
</template>

<script>
import orderMixin from '@/utils/mixins/order';

export default {
    components: {
        Cdocumentation: () => import(/* webpackChunkName: "documentation" */ '@clearwave/odoro-markup/lib/vue/documentation.vue'),
    },
    mixins: [orderMixin],
    props: {
        value: {},
        settings: {
            type: Object,
            default () { return {}; },
        },
        values: {},
        id: {
            type: String,
        },
        type: {
            required: true,
            type: String,
        },
        stateId: {
            type: String,
            required: true,
        },
        maxWidth: {},
        account: {},
        title: {},
        focused: {},
        focusable: {},
    },
    data () {
        return {
            model: this.value,
            dataQa: this.type + '.' + this.id,
        };
    },
    computed: {
        eType () {
            if (this.$root.appConfig.mode === 'inline') {
                if (['linemenu', 'boxmenu', 'options'].indexOf(this.type) !== -1) {
                    return 'combobox';
                }
                if (['date'].indexOf(this.type) !== -1) {
                    return 'datesimple';
                }
                if (['textarea'].indexOf(this.type) !== -1) {
                    return 'input';
                }

                return this.type;
            }
            return this.type;
        },
        eSettings () {
            let settings = {};
            Object.keys(this.settings).forEach(key => {
                if (this.settings[key] !== null && this.settings[key] !== undefined) {
                    settings[key] = this.settings[key];
                }
            });

            return settings;
        },
        properties () {
            return {
                id: this.id,
                title: this.title,
                values: this.options,
                dataQa: this.dataQa,
                maxWidth: this.maxWidth,
                ...(this.$root.appConfig.mode === 'inline' ? { placeholder: this.title } : {}),
                ...this.eSettings,
            };
        },
        options () {
            return this.order_options(this.eValues);
        },
        eValues () {
            let values = typeof (this.values) === 'string' ? JSON.parse(this.values) : this.values;
            if (values instanceof Array) {
                return this.values.map(value => {
                    if (value.id === undefined) {
                        value.id = null;
                    }

                    return value;
                });
            } else {
                return values;
            }
        },
    },
    watch: {
        model () {
            if (this.model instanceof Array) {
                if (this.value === null || this.value.join('') !== this.model.join('')) {
                    this.$emit('input', this.model);
                    return;
                }
            }

            if (this.model !== this.value) {
                this.$emit('input', this.model);
            }
        },
        value () {
            if (this.model !== this.value) {
                this.model = this.value;
            }
        },
        focused: {
            handler () {
                this.$emit(this.focused ? 'focus' : 'blur');
            },
            immediate: true,
        },
    },
    beforeCreate () {
        // beforeCreate is to manage circular dependencies
        this.$options.components.Clinemenu = require('@/vue/blocks/linemenu.vue').default;
        this.$options.components.Caddress = require('@/vue/blocks/address.vue').default;
        this.$options.components.Cboxmenu = require('@/vue/blocks/boxmenu.vue').default;
        this.$options.components.Ccheckbox = require('@/vue/blocks/checkbox.vue').default;
        this.$options.components.CcheckboxList = require('@/vue/blocks/checkbox-list.vue').default;
        this.$options.components.Ccombobox = require('@/vue/blocks/combobox.vue').default;
        this.$options.components.Cdate = require('@/vue/blocks/calendar.vue').default;
        this.$options.components.Cdatesimple = require('@/vue/blocks/datesimple.vue').default;
        this.$options.components.Cinput = require('@/vue/blocks/input.vue').default;
        this.$options.components.ClinemenuList = require('@/vue/blocks/linemenu-list.vue').default;
        this.$options.components.Cmessage = require('@/vue/blocks/message.vue').default;
        this.$options.components.Coptions = require('@/vue/blocks/options.vue').default;
        this.$options.components.Cradio = require('@/vue/blocks/radio.vue').default;
        this.$options.components.Csignature = require('@/vue/blocks/signature.vue').default;
        this.$options.components.Ctime = require('@/vue/blocks/time.vue').default;
        this.$options.components.Ctitle = require('@/vue/blocks/title.vue').default;
        this.$options.components.CuploadImage = require('@/vue/blocks/upload-image.vue').default;
        this.$options.components.Ctextarea = require('@/vue/blocks/textarea.vue').default;
        this.$options.components.CautoGeoLocation = require('@/vue/blocks/autogeolocation.vue').default;
        this.$options.components.Ciframe = require('@/vue/blocks/iframe.vue').default;
        this.$options.components.CaddressSearch = require('@/vue/blocks/address-search.vue').default;
    },
};
</script>
